import { Route } from "react-router-dom";
import { TrendsScreen } from "./TrendsScreen";

export const routes = <Route path="trends" Component={TrendsScreen} />;
